<div class="otsc-header">
    <app-header></app-header>
    <div role="navigation" class="ot-level">
        <div class="ot-level__left">
            <div class="ot-level__item">
                <app-tabs [identifier]="'otsc-nav-menu-tabs'" [tabPaddingLeft]="tabPaddingLeft" (selected)="onSelectedTabChange($event)" [tabs]="tabs" [color]="TabColor.BUSINESS_BG_UNSET" [selectedIndex]="activeTabIndex" [autoScrollable]="false" [selectOnInit]="false" [resizeOnInit]="false" [useWindowWidth]="false"></app-tabs>
            </div>
        </div>
        <div class="ot-level__center">
            <div class="ot-level__item"></div>
        </div>
        <div class="ot-level__right">
            <div class="ot-level__item">
                <span id="otsc-main-env" [title]="currentSolEnvName">{{currentSolEnvName}}</span>
            </div>
        </div>
    </div>
</div>
<div class="otsc-main-body" role="main">
    <router-outlet></router-outlet>
</div>